/**
 * Whether the signed-in reader may have a chat file's content, by its subject matters (#6993). The
 * server sends it by name, as it sends `FileScanStatus`.
 *
 * Decided for the reader alone, unlike `FileScanStatus`, which refuses everybody. `undefined` means the
 * payload did not say; the download then stays offered, and the API still refuses it with the reason.
 */
export enum MessageAttachmentContentAccess {
  /** The reader holds a grant for every subject matter the file has, or it has none. */
  Allowed = "Allowed",
  /** The file has a subject matter the reader holds no grant for. Its download is refused. */
  SubjectMatterRestricted = "SubjectMatterRestricted",
}
